// Udyan 28 Sep: accordions that open one at a time, with a 200ms height animation (design-system motion:
// 120–200ms, standard easing, no bounce). Respects "reduce motion".
//   1. Product-details tabs under the buy box      (product pages)
//   2. FAQ (collapsible-content section)          (product pages only)
//   3. Mobile menu sub-menus (Tea, About, Tea by …) (every page)
//   4. Mobile footer menus (About, Support)         (every page, below 750px)
// 3 Oct: the mobile menu also reopens the way it was left, and closes when search is opened (section 5 below).
// Loaded by sections/footer.liquid (every page) and sections/main-product.liquid; the guard below runs it once.
(function () {
  if (window.utAccordion) return;
  window.utAccordion = true;

  var DURATION = 200;
  var EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mobile = window.matchMedia('(max-width: 749px)');
  var running = new WeakMap();

  function stop(el) {
    var previous = running.get(el);
    if (previous) previous.cancel();
  }

  function animateHeight(el, from, to, done) {
    stop(el);
    if (reduceMotion || !el.animate || from === to) {
      if (done) done();
      return;
    }
    el.style.overflow = 'hidden';
    var anim = el.animate([{ height: from + 'px' }, { height: to + 'px' }], { duration: DURATION, easing: EASING });
    running.set(el, anim);
    anim.onfinish = function () {
      running.delete(el);
      el.style.overflow = '';
      if (done) done();
    };
    anim.oncancel = function () {
      running.delete(el);
      el.style.overflow = '';
    };
  }

  /* ---------- <details> accordions (1–3) ---------- */

  // Keep aria-expanded, and custom.js's plus/minus icons on the product tabs, in step with what we open or close.
  function markState(details, isOpen) {
    var summary = details.querySelector(':scope > summary');
    if (!summary) return;
    summary.setAttribute('aria-expanded', String(isOpen));
    var plus = summary.querySelector('.icon_plus');
    var minus = summary.querySelector('.icon_minus');
    if (plus) plus.style.display = isOpen ? 'none' : '';
    if (minus) minus.style.display = isOpen ? '' : 'none';
  }

  function openDetails(details) {
    details.dataset.utState = 'open';
    markState(details, true);
    var start = details.offsetHeight; // current height, even mid-animation
    stop(details);
    details.open = true;
    animateHeight(details, start, details.offsetHeight);
  }

  function closeDetails(details) {
    details.dataset.utState = 'closing';
    markState(details, false);
    var start = details.offsetHeight;
    stop(details);
    details.open = false;
    var end = details.offsetHeight;
    details.open = true;
    animateHeight(details, start, end, function () {
      details.open = false;
      details.dataset.utState = 'closed';
    });
  }

  function membersOf(details) {
    var productInfo = details.closest('.product__info-container');
    if (productInfo) return productInfo.querySelectorAll('.product__accordion details');
    var faq = details.closest('.collapsible-content');
    if (faq) return faq.querySelectorAll('details');
    var list = details.parentElement && details.parentElement.parentElement; // menu: <ul> > <li> > <details>
    return list ? list.querySelectorAll(':scope > li > details') : [];
  }

  function toggleDetails(details) {
    if (details.open && details.dataset.utState !== 'closing') {
      closeDetails(details);
      return;
    }
    Array.prototype.forEach.call(membersOf(details), function (other) {
      if (other !== details && other.open && other.dataset.utState !== 'closing') closeDetails(other);
    });
    openDetails(details);
  }

  // Product tabs + FAQ: bubble-phase listener on the summary, so the theme's own aria and icon handlers still run first.
  function onPageSummaryClick(event) {
    var details = event.currentTarget.parentElement;
    if (!details || details.tagName !== 'DETAILS') return;
    event.preventDefault();
    toggleDetails(details);
  }

  function bindPageAccordions() {
    if (!document.querySelector('.product__info-container')) return; // product pages only
    var selector = '.product__info-container .product__accordion details > summary, .collapsible-content details > summary';
    document.querySelectorAll(selector).forEach(function (summary) {
      if (summary.dataset.utAccordion) return;
      summary.dataset.utAccordion = '1';
      summary.addEventListener('click', onPageSummaryClick);
    });
  }

  // Mobile menu sub-menus: capture-phase listener on the drawer, so Dawn's sub-menu handler (which only re-marks
  // the item as open) doesn't run. The drawer's own open/close toggle is outside #menu-drawer and stays with Dawn.
  function bindMenuDrawer() {
    var drawer = document.getElementById('menu-drawer');
    if (!drawer || drawer.dataset.utAccordion) return;
    drawer.dataset.utAccordion = '1';
    drawer.addEventListener(
      'click',
      function (event) {
        var summary = event.target.closest('summary');
        if (!summary || !drawer.contains(summary)) return;
        var details = summary.parentElement;
        if (!details || details.tagName !== 'DETAILS') return;
        if (!details.id || details.id.indexOf('Details-menu-drawer-') !== 0) return; // menu items only
        event.preventDefault();
        event.stopPropagation();
        toggleDetails(details);
      },
      true
    );
  }

  /* ---------- Mobile footer menus (4) ---------- */
  // custom.js toggles ".mobile-accordian" lists with jQuery and marks the open block "close-menu" (rotates the arrow).
  // Below 750px we take over (capture phase stops custom.js's handler) to animate and keep one open.

  function footerBlocks() {
    return Array.prototype.filter.call(document.querySelectorAll('.footer-block--menu'), function (block) {
      return block.querySelector('.mobile-accordian');
    });
  }

  function isFooterOpen(block) {
    return block.classList.contains('close-menu');
  }

  function openFooter(block) {
    var list = block.querySelector('.mobile-accordian');
    block.classList.add('close-menu');
    var start = list.style.display === 'block' ? list.offsetHeight : 0;
    stop(list);
    list.style.display = 'block';
    animateHeight(list, start, list.offsetHeight);
  }

  function closeFooter(block) {
    var list = block.querySelector('.mobile-accordian');
    block.classList.remove('close-menu');
    animateHeight(list, list.offsetHeight, 0, function () {
      list.style.display = 'none';
    });
  }

  function bindFooter() {
    footerBlocks().forEach(function (block) {
      var heading = block.querySelector('.footer-block__heading');
      if (!heading || heading.dataset.utAccordion) return;
      heading.dataset.utAccordion = '1';
      block.addEventListener(
        'click',
        function (event) {
          if (!mobile.matches || !heading.contains(event.target)) return;
          event.stopPropagation();
          if (isFooterOpen(block)) {
            closeFooter(block);
            return;
          }
          footerBlocks().forEach(function (other) {
            if (other !== block && isFooterOpen(other)) closeFooter(other);
          });
          openFooter(block);
        },
        true
      );
    });
  }

  /* ---------- Mobile menu drawer: keep its state; close it when search opens (5) ---------- */

  function bindHeaderDrawer() {
    var headerDrawer = document.querySelector('header-drawer');
    if (!headerDrawer || headerDrawer.dataset.utKeep) return;
    if (typeof headerDrawer.closeMenuDrawer !== 'function') return; // Dawn's element isn't ready
    headerDrawer.dataset.utKeep = '1';

    // Dawn shuts every sub-menu when the drawer closes, so "Tea" was open on the first visit and shut on the next.
    // Put the sub-menus back the way the visitor left them (their aria-expanded was never changed, so it stays right).
    var dawnClose = headerDrawer.closeMenuDrawer;
    headerDrawer.closeMenuDrawer = function (event, elementToFocus) {
      var wasOpen = Array.prototype.filter.call(this.querySelectorAll('#menu-drawer details'), function (details) {
        return details.open && details.dataset.utState !== 'closing';
      });
      dawnClose.call(this, event, elementToFocus);
      wasOpen.forEach(function (details) {
        details.open = true;
      });
    };

    // Search tapped while the menu is open: close the menu first (search used to open on top of it).
    var main = headerDrawer.querySelector('details');
    var menuButton = main && main.querySelector('summary');
    if (!menuButton) return;
    document.querySelectorAll('.header details-modal.header__search summary').forEach(function (searchButton) {
      searchButton.addEventListener(
        'click',
        function (event) {
          if (!main.classList.contains('menu-opening')) return;
          headerDrawer.closeMenuDrawer(event, menuButton);
          menuButton.setAttribute('aria-expanded', 'false'); // also removes the dark layer over the page
        },
        true
      );
    });
  }

  function init() {
    bindPageAccordions();
    bindMenuDrawer();
    bindFooter();
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('header-drawer').then(bindHeaderDrawer);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
